module.exports = __webpack_public_path__ + "img/bagOpen.fb9b04ae.png";